import {useEffect, useState} from 'react'
import {is1024} from '../shared/caps'

export const useIs1024 = () => {
    const [is1024State, setIs1024State] = useState(is1024())
    useEffect(() => {
        const handler = () => setIs1024State(is1024())
        window.addEventListener('resize', handler)
        return () => window.removeEventListener('resize', handler)
    }, [])
    return is1024State
}
